module.exports = __webpack_public_path__ + "static/media/signal-alt-1.6c551bc0.svg";